import type { ReactNode } from 'react';

interface MetricPrimaryStripProps {
  children: ReactNode;
  'aria-label': string;
  'data-testid'?: string;
  className?: string;
}

/** Fila de KPIs fuertes (nivel primary): 3–5 métricas del fold. */
export function MetricPrimaryStrip({
  children,
  'aria-label': ariaLabel,
  'data-testid': testId,
  className = '',
}: MetricPrimaryStripProps) {
  return (
    <div
      className={`metric-primary-strip bi-stagger ${className}`.trim()}
      role="list"
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
